import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { LinkButton } from '../LinkButton';
import * as Styled from './TransactionDetails.styled';
import { setColorWithOpacityCss } from '../../utils/setColorWithOpacityCss';
import { formatCurrency } from '../../features/passport/formatCurrency';
import { StyledContentContainer } from '../../containers/StyledContentContainer.styled';
import { OrderDetails } from './OrderDetails';
import { KeyboardArrowDown } from '../../svgs';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The `TransactionDetails` content block is displayed after a user submits a donation,
 * and it includes the details of the donation.
 */
export const TransactionDetails = ({
  transactionDetails,
  cssBackgroundColor,
  cssBackgroundColorOpacity,
  cssColor,
  parentLayoutInfo,
  campaignLocale = 'en-US',
  ...rest
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const {
    t
  } = useTranslation('blocks.transactionDetails');
  return /*#__PURE__*/_jsx(StyledContentContainer, {
    parentLayoutInfo: parentLayoutInfo,
    children: /*#__PURE__*/_jsxs(Styled.Container, {
      "data-id": "cp-transaction-details",
      ...rest,
      cssBackgroundColor: setColorWithOpacityCss(cssBackgroundColor, cssBackgroundColorOpacity),
      cssColor: cssColor,
      parentLayoutInfo: parentLayoutInfo,
      children: [/*#__PURE__*/_jsx(Styled.Heading, {
        children: t('TransactionDetails.summary.heading', 'Donation summary')
      }), /*#__PURE__*/_jsx(Styled.Description, {
        children: /*#__PURE__*/_jsx(Trans, {
          t: t,
          i18nKey: "TransactionDetails.summary.description",
          values: {
            email: transactionDetails?.email
          },
          components: {
            email: /*#__PURE__*/_jsx(Styled.ForceWordBreakAnywhere, {})
          },
          defaults: "We've sent a confirmation receipt to <email>{{email}}</email>."
        })
      }), /*#__PURE__*/_jsxs(Styled.Detail, {
        children: [/*#__PURE__*/_jsx(Styled.Label, {
          children: t('TransactionDetails.confirmationNumber.label', 'Confirmation Number')
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Styled.ForceWordBreakAnywhere, {
            children: transactionDetails?.confirmationNumber || ''
          })
        })]
      }), /*#__PURE__*/_jsxs(Styled.Detail, {
        children: [/*#__PURE__*/_jsx(Styled.Label, {
          children: t('TransactionDetails.feesCovered.label', 'Fees covered')
        }), /*#__PURE__*/_jsx("div", {
          children: formatCurrency({
            currencyCode: transactionDetails?.currencyCode || 'USD',
            amount: transactionDetails?.donorCoveredFee || '',
            locale: campaignLocale
          })
        })]
      }), /*#__PURE__*/_jsxs(Styled.Detail, {
        children: [/*#__PURE__*/_jsx(Styled.Label, {
          children: t('TransactionDetails.totalDonation.label', 'Total donation')
        }), /*#__PURE__*/_jsx("div", {
          children: formatCurrency({
            currencyCode: transactionDetails?.currencyCode || 'USD',
            amount: transactionDetails?.amount || '',
            locale: campaignLocale
          })
        })]
      }), /*#__PURE__*/_jsx(Styled.OrderDetailsHeadContainer, {
        children: /*#__PURE__*/_jsxs(Styled.OrderDetailsHead, {
          children: [/*#__PURE__*/_jsx(Styled.Label, {
            id: "transaction-details-order-details-label",
            children: t('TransactionDetails.orderDetails.label', 'Donation details')
          }), /*#__PURE__*/_jsx(Styled.ArrowDownContainer, {
            onClick: () => setIsOpen(!isOpen),
            isOpen: isOpen,
            "aria-expanded": isOpen ? 'true' : 'false',
            "aria-controls": "transaction-details-order-details",
            "aria-labelledby": "transaction-details-order-details-label",
            children: /*#__PURE__*/_jsx(KeyboardArrowDown, {})
          })]
        })
      }), /*#__PURE__*/_jsx(OrderDetails, {
        id: "transaction-details-order-details",
        orderItems: transactionDetails?.orderItems,
        isOpen: isOpen,
        campaignLocale: campaignLocale,
        currencyCode: transactionDetails?.currencyCode || 'USD'
      }), /*#__PURE__*/_jsx(LinkButton, {
        href: transactionDetails?.href ?? '',
        content: t('TransactionDetails.manageDonationButton.label', 'Manage donation'),
        cssColor: "white",
        cssBackgroundColor: "#252528",
        alignXPreset: "right",
        "data-id": "cp-transaction-details-manage"
      })]
    })
  });
};